import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '../services/navigation-gaurd.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit, CanComponentDeactivate {

  constructor(private readonly authService: AuthService,
    private readonly _router: Router) { }

canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    // if( this.registrationForm.dirty) {
    //   return confirm('Form has unsaved changes.' + 
    //   ' Any Data entered will be lost. Do you want to leave?');
    // } else {
    //   return true;
    // }
    return true;
   }
   
  ngOnInit() {
  }

  public redirectToHome() {

    if(this.authService.isLoggedIn) {
      this._router.navigateByUrl('/app-landing');
    }
    else {
      this._router.navigateByUrl('/app-home');
    }
  }
}
